import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Grid, Button, NativeSelect } from '@material-ui/core/'
import DeleteModal from '../DeleteModal'
import apiAdmin from '../../../../../../../api/admin'
import filterIcon from '../../../../../../../assetss/img/filterIcon.svg'
import avatarIcon from '../../../../../../../assetss/img/avatarIcon.svg'
import './index.scss'

const SelectSory = ({ count, stories, setId }) => {
  const history = useHistory()
  return (
    <div className='custonStorySelect'>
      <NativeSelect
        labelId='demo-customized-select-label'
        id='demo-customized-select'
        defaultValue={count}
        onChange={e => history.push(`/admin/story/${e.target.value}`)}
      >
        <option value={count}>{count}</option>
        {stories?.map(({ title, uuid }) => (
          <option value={uuid} onClick={() => setId(uuid)} key={uuid}>{title}</option>
        ))}
      </NativeSelect>
    </div>
  )
}

const Users = () => {
  const { user } = useSelector(({ session }) => session)
  const [users, setUsers] = useState([])
  const [deleteUser, setDeleteUser] = useState({
    name: '',
    id: '',
  })
  const [open, setOpen] = useState(false)

  const getUsers = () => {
    apiAdmin?.getUsers(user?.accessKey)
      .then(({ data }) => setUsers(data?.statistics))
  }

  const onDelete = () => {
    apiAdmin.deleteUser(user?.accessKey, deleteUser?.id)
      .then(() => {
        getUsers()
        setDeleteUser({})
      })
      .finally(() => setOpen(false))
  }

  useEffect(() => {
    getUsers()
  }, [])

  return (
    <Grid className='tableUsers'>
      <DeleteModal open={open} name={deleteUser?.name} setOpen={setOpen} setDeleteUser={setDeleteUser} onDelete={onDelete} />
      <Grid className='tableHeader'>
        <Grid className='headerName'>
          Name <img src={filterIcon} className='iconFilter' />
        </Grid>
        <Grid className='headerEmail'>
          Email <img src={filterIcon} className='iconFilter' />
        </Grid>
        <Grid className='headerMeetings'>
          Meetings <img src={filterIcon} className='iconFilter' />
        </Grid>
        <Grid className='headerStories'>
          Stories <img src={filterIcon} className='iconFilter' />
        </Grid>
        <Grid className='headerCity'>
          City <img src={filterIcon} className='iconFilter' />
        </Grid>
      </Grid>
      {users?.map(({ email, name, storiesCount, town, meetingsCount, uuid, stories }) => (
        <Grid className='tableBody' key={email}>
          <Grid className='bodyName'>
            <img src={avatarIcon} className='iconAvatar' /> {name}
          </Grid>
          <Grid className='bodyEmail'>
            {email}
          </Grid>
          <Grid className='bodyMeetings'>
            {meetingsCount}
          </Grid>
          <Grid className='bodyStories'>
            <SelectSory count={storiesCount} stories={stories} />
          </Grid>
          <Grid className='bodyCity'>
            <Grid>{town}</Grid>
            <Button
              onClick={() => {
                setDeleteUser({
                  name,
                  id: uuid,
                })
                setOpen(true)
              }}
              className='btnCansel'
              variant='contained'
            >
              DELETE
            </Button>
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}

export default Users
